<section class="contact-us py-4">
  <section class="relative h-[500px] z-10 bg-[url('/images/contact-us.jpg')] bg-cover bg-center mt-[-6.6875rem]">
    <div class="absolute inset-0 bg-white opacity-50 z-10"></div>

    <div class="absolute inset-0 z-20 flex flex-col gap-4 items-center justify-center">
      <app-back />
      <h4 class="text-secondary dark:text-white text-4xl font-bold">
        {{ "Contact.Page_Title" | translate }}
      </h4>
      <h3
        class="text-[#161A25] text-xs lg:text-base w-80 md:w-195 sm:text-base font-medium text-center dark:text-[#F2F2F2]">
        {{ "Contact.Page_Subtitle" | translate }}
      </h3>
    </div>
  </section>

  <div class="bg-[#37377D] py-4 text-white">
    <div class="flex flex-col md:flex-row justify-center items-center gap-2 text-sm">
      <h4>{{ "Contact.Customer_Support" | translate }}</h4>

      <div class="flex items-center gap-2">
        <img src="/icons/msg.svg" alt="message" />
        <a href="mailto:support&#64;dreamnfly.com">
          support&#64;dreamnfly.com
        </a>
      </div>
    </div>
  </div>

  <div class="container max-w-full mx-auto px-4 cw:px-[max(32px,calc((100%_-_1328px)/2))]">
    <div
      class="bg-white dark:bg-second-dark mt-5 text-sm common-border dark:border-[#DEEFFD] rounded-2xl p-4 shadow flex flex-col gap-4">
      <h4 class="font-medium text-2xl dark:text-[#F2F2F2]">
        {{ "Contact.Title" | translate }}
      </h4>

      <app-contact-form />
    </div>
  </div>
</section>